import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from 'react-router-dom';
import CloseIcon from '@material-ui/icons/Close';
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
	ModalDesign: {
		marginRight: "106px",
	},
	selectorValues: {
		marginRight: "300px",
	},
	projTitleActive: {
		backgroundColor: '#008EC5',
		color: '#fff',
		padding: '3px',
		borderRadius: '3px'
	},
	buttonStyleCancel: {
		float: 'right',
		textTransform: 'none',
		margin: '4px',
		color: 'white',
		backgroundColor: '#008EC5 !important',
		border: '1px solid #1F4E79 !important',
		borderColor: '#1F4E79',
	},
	scrollList: {
		maxHeight: '200px',
		overflowY: 'auto',
		overflowX: 'hidden'
	},
	modalBoxContent: {
		maxHeight: '100vh',
		display: 'flex !important',
		justifyContent: 'center !important',
		alignItems: 'center !important',
		position: 'fixed',
		top: '0',
		left: '0',
		right: '0',
		bottom: '0',
		zIndex: '1050'
	},
	modalBody: {
		flex: 'unset',
		padding: '10px 10px 15px',
		maxHeight: '80vh',
		overflowY: 'auto',
		border: 'none !important'
	},
	modalBodyDark: {
		flex: 'unset',
		padding: '10px 10px 15px',
		backgroundColor: '#292929',
		maxHeight: '80vh',
		overflowY: 'auto',
		border: 'none !important'
	},
	modalClassContent: {
		width: '96%',
		maxWidth: '600px',
		maxHeight: '90vh',
		position: 'fixed',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		overflowY: 'auto',
		margin: 'auto',
		border: 'none !important',
		outline: 'none !important'
	},
	colorContainer: {
		backgroundColor: '#EEEEEE',
		paddingTop: '15px',
		paddingBottom: '70px',
		marginLeft: '5px',
		marginRight: '4px',
		paddingRight: '10px',
		borderRadius: '5px',
		paddingLeft: '10px',
		minHeight: '300px'
	},
	colorContainerDark: {
		backgroundColor: '#56545473',
		paddingTop: '15px',
		paddingBottom: '70px',
		marginLeft: '5px',
		marginRight: '4px',
		paddingRight: '10px',
		borderRadius: '5px',
		paddingLeft: '10px',
		minHeight: '300px'
	},
	closeButton: {
		position: 'absolute',
		right: '10px',
		top: '10px'
	},
	title: {
		// View names can be one long unbroken token; let it wrap inside the box
		// and keep clear of the close icon in the top-right corner.
		overflowWrap: 'anywhere',
		wordBreak: 'break-word',
		paddingRight: '24px'
	},
	scopeOption: {
		display: 'flex',
		alignItems: 'center',
		marginBottom: '6px',
		cursor: 'pointer'
	},
	footerDiv: {
		padding: "0 10px",
	}
}));

const SCOPE_MEMBERS = 'members';
const SCOPE_ENTITY = 'entity';

function ShareViewModal(props) {
	// react-bootstrap forwards anything it does not recognise to a DOM node, so the
	// feature props are pulled out here instead of being spread onto <Modal>.
	const { viewName: _vn, data: _d, entityShared: _es, shareView: _sv,
	        removeRecipient: _rr, removeEntityShare: _res, ...modalProps } = props;
	const classes = useStyles();
	const [scope, setScope] = useState(SCOPE_MEMBERS);
	const [selectData, setSelectData] = useState([]);
	const [searchTerm, setSearchTerm] = useState('');
	const toggle = useSelector(state => state.setToggle.toggle);

	const viewName = props.viewName || '';

	const getSelectVal = (id, alreadyShared) => {
		// Someone who already has the view has nothing to add; showing them greyed out
		// is how the owner finds out who they shared it with previously.
		if (alreadyShared) {
			return;
		}
		if (selectData.includes(id)) {
			setSelectData(selectData.filter(e => e !== id));
		} else {
			setSelectData([...selectData, id]);
		}
	}

	const resetState = () => {
		setScope(SCOPE_MEMBERS);
		setSelectData([]);
		setSearchTerm('');
	}

	const closeModal = () => {
		props.onHide();
		resetState();
	}

	const shareThisView = () => {
		props.shareView({
			viewName: viewName,
			scope: scope,
			userIds: scope === SCOPE_MEMBERS ? selectData : []
		});
		resetState();
	}

	// Entity-wide sharing needs no selection; member sharing needs at least one person.
	const canShare = scope === SCOPE_ENTITY ? !props.entityShared : selectData.length > 0;

	return (
		<Modal
			{...modalProps}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered={true}
			contentClassName={classes.modalClassContent}
			className={classes.modalBoxContent}
			backdrop="static"
			dialogClassName="border-0"
		>
			<Link href="#" onClick={(e) => e.preventDefault()} className={classes.closeButton + "  appTextColor"}><CloseIcon onClick={closeModal} /></Link>
			<div className={toggle ? classes.modalBody : classes.modalBodyDark + " appTextColor"}>
				<div className={toggle ? classes.colorContainer : classes.colorContainerDark}>
					<h5 className={classes.title}>
						&nbsp;<b>{'Share "' + viewName + '"'}</b>
					</h5>
					<div className={classes.ModalDesign}>
						<p className="pl-2 pb-0">
							{'Choose who can use this view.'}
						</p>
					</div>

					<div className="pl-2 pb-2">
						<label className={classes.scopeOption} htmlFor="shareViewScopeEntity">
							<input
								type="radio"
								id="shareViewScopeEntity"
								name="shareViewScope"
								checked={scope === SCOPE_ENTITY}
								onChange={() => { setScope(SCOPE_ENTITY); setSelectData([]); }}
								style={{ marginRight: '8px', transform: 'scale(1.2)' }}
							/>
							<span>Share with everyone in the group</span>
						</label>
						<label className={classes.scopeOption} htmlFor="shareViewScopeMembers">
							<input
								type="radio"
								id="shareViewScopeMembers"
								name="shareViewScope"
								checked={scope === SCOPE_MEMBERS}
								onChange={() => setScope(SCOPE_MEMBERS)}
								style={{ marginRight: '8px', transform: 'scale(1.2)' }}
							/>
							<span>Share with selected members</span>
						</label>
					</div>

					{scope === SCOPE_MEMBERS && (
						<div className={classes.selectorValues + " mx-4"}>
							<input
								type="text"
								placeholder="Search by name..."
								value={searchTerm}
								onChange={(e) => setSearchTerm(e.target.value)}
								style={{
									width: '50%',
									padding: '6px 10px',
									marginBottom: '8px',
									marginLeft: '-2px',
									border: '1px solid #ccc',
									borderRadius: '4px',
									fontSize: '14px',
									backgroundColor: toggle ? '#fff' : '#666666',
									color: toggle ? '#000' : '#fff'
								}}
							/>
							<ul className={"list-inline " + classes.scrollList}>
								{
									props.data && Object.keys(props.data)
										.filter((dta) => props.data[dta].full_name.toLowerCase().includes(searchTerm.toLowerCase()))
										.map((dta, i) => {
											const person = props.data[dta];
											// covered_by_entity is per user: an admin's roster reaches
											// outside their entity, and those people are not covered.
											const already = person.already_shared || person.covered_by_entity;
											return <li key={i}>
												<span className={(already ? '' : 'cursorPointer ') + (selectData.includes(person.user_id) ? classes.projTitleActive : '')}
													  style={already ? {opacity: 0.55} : {}}
													  onClick={() => getSelectVal(person.user_id, already)}>{person.full_name}</span>
												{person.already_shared &&
													<span style={{marginLeft: '8px', fontSize: '12px', opacity: 0.7}}>
														already has this view
														{props.removeRecipient &&
															<>
																{' \u00b7 '}
																<a href="#" onClick={(e) => {e.preventDefault(); props.removeRecipient(person.user_id);}}>remove</a>
															</>
														}
													</span>
												}
												{!person.already_shared && person.covered_by_entity &&
													<span style={{marginLeft: '8px', fontSize: '12px', opacity: 0.7}}>
														covered by the group share
													</span>
												}
											</li>
										})
								}
							</ul>
							{(!props.data || Object.keys(props.data).length === 0) &&
								<p>No colleagues available to share with.</p>
							}
						</div>
					)}

					{scope === SCOPE_ENTITY && (
						<div className={classes.selectorValues + " mx-4"}>
							<p>
								{props.entityShared
									? 'This view is already shared with everyone in your group.'
									: 'Everyone in your group will see this view in their Saved Views list.'}
								{props.entityShared && props.removeEntityShare &&
									<>
										{' '}
										<a href="#" onClick={(e) => {e.preventDefault(); props.removeEntityShare();}}>Stop sharing with the group</a>
									</>
								}
							</p>
						</div>
					)}

					<div className={classes.footerDiv + " float-right"}>
						<Button
							color={canShare ? "secondary" : "default"}
							variant="contained"
							className={"text-capitalize mr-2 " + (canShare ? 'accountInfo' : 'cancelButtonDisable')}
							onClick={shareThisView}
							disableRipple={true}
							disabled={!canShare}
						>Share View</Button>
						<Button
							onClick={closeModal}
							className={classes.buttonStyleCancel}
							color="secondary"
							disableRipple={true}
							variant="contained"
						>Cancel</Button>
					</div>
				</div>
			</div>
		</Modal>
	);
}

export default ShareViewModal;
